
export enum ConnectionState {
    Unknown = 'Unknown',
    Connected = 'Connected',
    Disconnected = 'Disconnected'
}
